import { formatPriceInput } from "shared/price-input-formatter";
import { SearchAgentProfileTimeline } from "model/search-agent-profile";

/**
 * Formatting for the Search Profile fields the agent learns about price, timeline and
 * pre-approval. Each returns undefined when the field is unset, which is what hides its row.
 */

export const formatProfilePrice = (priceMin?: number, priceMax?: number) => {
	if (priceMin != null && priceMax != null) {
		return `${formatPriceInput(priceMin)} – ${formatPriceInput(priceMax)}`;
	}
	if (priceMax != null) {
		return `Up to ${formatPriceInput(priceMax)}`;
	}
	if (priceMin != null) {
		return `From ${formatPriceInput(priceMin)}`;
	}
	return undefined;
};

/**
 * "April 2026" for a window inside one month, "Apr – Jun 2026" for a longer one, with the year
 * on both ends when the window crosses one. A window with only one end set reads as that month.
 */
export const formatProfileTimeline = (timeline?: SearchAgentProfileTimeline) => {
	if (!timeline) {
		return undefined;
	}
	if (timeline.justBrowsing) {
		return "Just browsing";
	}
	const { start, end } = timeline;
	if (start && end) {
		if (start.isSame(end, "month")) {
			return start.format("MMMM YYYY");
		}
		if (start.isSame(end, "year")) {
			return `${start.format("MMM")} – ${end.format("MMM YYYY")}`;
		}
		return `${start.format("MMM YYYY")} – ${end.format("MMM YYYY")}`;
	}
	const only = start || end;
	return only ? only.format("MMMM YYYY") : undefined;
};

export const formatProfilePreApproval = (preApproved?: boolean) => {
	if (preApproved == null) {
		return undefined;
	}
	return preApproved ? "Pre-approved" : "Not pre-approved";
};
